class CustomVideo extends HTMLElement {
  constructor() {
    super();
    this.pauseOnClick = this.dataset.pauseOnClick;
    this.playMode = this.dataset.playMode;
    this.playButton = this.querySelector(".custom-play--button");
    this.muteButton = this.querySelector(".custom-mute--button");
    this.videos = this.querySelectorAll("video");
    this.videosArray = Array.from(this.videos);
    this.sources = this.videosArray.map((video) =>
      video.querySelector("source")
    );
    this.visibleVideos = this.videosArray.filter(
      (video) => getComputedStyle(video).display !== "none"
    );
    this.video = this.visibleVideos[0];
    if (this.video) {
      this.load();
    }
    window.addEventListener("load", () => {
      if (this.videos.length) {
        if ("IntersectionObserver" in window) {
          this.startObserving();
        } else {
          this.videos.forEach((video) => video.play());
        }
      }
    });
  }
  connectedCallback() {
    this.videosArray.forEach((video, index) => {
      const isMobileOnly = video.classList.contains("mobile-only");
      const isDesktopOnly = video.classList.contains("desktop-only");
      if ((isMobile() && isMobileOnly) || (!isMobile() && isDesktopOnly)) {
        const source = this.sources[index];
        if (source) {
          source.setAttribute("src", source.dataset.src);
        }

        video.removeChild(source);
        video.appendChild(source);
      }
    });
  }
  startObserving() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust this threshold as needed
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) video.play();
        } else {
          if (!video.paused) video.pause();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    this.videos.forEach((container) => {
      observer.observe(container);
    });
  }
  load() {
    if (this.muteButton) {
      this.muteButton.addEventListener("click", this.toggleMute.bind(this));
    }
    if (this.playMode === "on-hover") {
      this.playOnHover();
    } else if (this.playButton && this.pauseOnClick) {
      this.playButton.addEventListener("click", this.togglePlay.bind(this));
    }
  }

  togglePlay() {
    if (this.video.paused || this.video.ended) {
      this.playButton.classList.add("paused");
      this.video.play();
    } else {
      this.playButton.classList.remove("paused");
      this.video.pause();
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    if (this.video.muted === true) {
      this.muteButton.classList.add("muted");
    } else {
      this.muteButton.classList.remove("muted");
    }
  }

  playOnHover() {
    // add "data-play-mode-trigger" on the parent that you want to trigger the hover action
    const hoverTrigger = this.closest("[data-play-mode-trigger]") || this;

    hoverTrigger.addEventListener("mouseenter", () => {
      if (this.video.paused) this.video.play();
    });

    hoverTrigger.addEventListener("mouseleave", () => {
      this.video.currentTime = 0;
      if (!this.video.paused) this.video.pause();
    });
  }
}

customElements.define("custom-video", CustomVideo);
